<div class="flex flex-col">
    <!-- Header -->
    <div class="flex flex-0 sticky top-0 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">
            <b>{{ 'workerAssignments.title' | transloco: { worker: data.workerName } }}</b>
        </div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-on-primary" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    @if (assignments()) {
        <div class="p-8">
            <div class="flex flex-col items-start 4xl:items-center flex-no-wrap mb-20 pb-4 overflow-y-auto">
                <div class="flex sticky top-0">
                    <div class="flex justify-center items-center flex-none w-36 p-2 border border-secondary">
                        {{ 'workerAssignments.customer/center' | transloco }}
                    </div>
                    <div class="flex justify-center items-center flex-none text-center w-36 p-2 border border-secondary">
                        {{ 'workerAssignments.contract/line' | transloco }}
                    </div>
                    <div class="flex justify-center items-center flex-none text-center w-24 p-2 border border-secondary">
                        {{ 'workerAssignments.laborContract' | transloco }}
                    </div>
                    <div class="flex justify-center items-center flex-none text-center w-90 p-2 border border-secondary">
                        {{ 'workerAssignments.position/agreement/contractType' | transloco }}
                    </div>
                    <div class="flex justify-center items-center flex-none text-center w-32 p-2 border border-secondary">
                        {{ 'workerAssignments.from' | transloco }}
                    </div>
                    <div class="flex justify-center items-center flex-none text-center w-32 p-2 border border-secondary">
                        {{ 'workerAssignments.to' | transloco }}
                    </div>
                    <div class="flex justify-center items-center flex-none text-center w-24 p-2 border border-secondary">
                        {{ 'workerAssignments.weekHours' | transloco }}
                    </div>
                    <div class="flex justify-center items-center flex-none text-center w-24 p-2 border border-secondary">
                        {{ 'workerAssignments.dayHours' | transloco }}
                    </div>
                    <div class="flex justify-center items-center flex-none text-center w-24 p-2 border border-secondary">
                        {{ 'workerAssignments.mondayHours' | transloco }}
                    </div>
                    <div class="flex justify-center items-center flex-none text-center w-24 p-2 border border-secondary">
                        {{ 'workerAssignments.tuesdayHours' | transloco }}
                    </div>
                    <div class="flex justify-center items-center flex-none text-center w-24 p-2 border border-secondary">
                        {{ 'workerAssignments.wednesdayHours' | transloco }}
                    </div>
                    <div class="flex justify-center items-center flex-none text-center w-24 p-2 border border-secondary">
                        {{ 'workerAssignments.thursdayHours' | transloco }}
                    </div>
                    <div class="flex justify-center items-center flex-none text-center w-24 p-2 border border-secondary">
                        {{ 'workerAssignments.fridayHours' | transloco }}
                    </div>
                    <div class="flex justify-center items-center flex-none text-center w-24 p-2 border border-secondary">
                        {{ 'workerAssignments.saturdayHours' | transloco }}
                    </div>
                    <div class="flex justify-center items-center flex-none text-center w-24 p-2 border border-secondary">
                        {{ 'workerAssignments.sundayHours' | transloco }}
                    </div>
                </div>

                @for (assignment of assignments(); track assignment.from) {
                    <div class="flex">
                        <div class="flex justify-center items-center flex-none w-36 p-2 border border-current">
                            {{ assignment.clienteId }} / {{ assignment.clienteCentroId }}
                        </div>
                        <div class="flex justify-center items-center flex-none w-36 p-2 border border-current">
                            {{ assignment.clienteContratoId }} / {{ assignment.clienteContratoLinea }}
                        </div>
                        <div class="flex justify-center items-center flex-none w-24 p-2 border border-current">
                            {{ assignment.laboralContratoId }}
                        </div>
                        <div class="text-left flex-none w-90 p-2 border border-current">
                            <div>{{ assignment.codigoPuestoContratoName }} ({{ assignment.codigoPuestoContratoId }})</div>
                            <div>{{ assignment.convenioContratoName }} ({{ assignment.convenioContratoId }})</div>
                            <div>{{ assignment.contractTypeName }} ({{ assignment.contractTypeId }})</div>
                        </div>
                        <div class="flex justify-center items-center flex-none w-32 p-2 border border-current">
                            {{ assignment.from }}
                        </div>
                        <div class="flex justify-center items-center flex-none w-32 p-2 border border-current">
                            {{ assignment.to }}
                        </div>
                        <div class="flex justify-center items-center flex-none w-24 p-2 border border-current">
                            {{ minutesToText(assignment.semana) }}
                        </div>
                        <div class="flex justify-center items-center flex-none w-24 p-2 border border-current">
                            {{ minutesToText(assignment.dia) }}
                        </div>
                        <div class="flex justify-center items-center flex-none w-24 p-2 border border-current">
                            {{ minutesToText(assignment.lunes) }}
                        </div>
                        <div class="flex justify-center items-center flex-none w-24 p-2 border border-current">
                            {{ minutesToText(assignment.martes) }}
                        </div>
                        <div class="flex justify-center items-center flex-none w-24 p-2 border border-current">
                            {{ minutesToText(assignment.miercoles) }}
                        </div>
                        <div class="flex justify-center items-center flex-none w-24 p-2 border border-current">
                            {{ minutesToText(assignment.jueves) }}
                        </div>
                        <div class="flex justify-center items-center flex-none w-24 p-2 border border-current">
                            {{ minutesToText(assignment.viernes) }}
                        </div>
                        <div class="flex justify-center items-center flex-none w-24 p-2 border border-current">
                            {{ minutesToText(assignment.sabado) }}
                        </div>
                        <div class="flex justify-center items-center flex-none w-24 p-2 border border-current">
                            {{ minutesToText(assignment.domingo) }}
                        </div>
                    </div>
                } @empty {
                    <div class="flex justify-center font-semibold px-6 py-8 md:px-8">
                        {{ 'workerAssignments.noAssignments' | transloco }}
                    </div>
                }
            </div>
        </div>
    } @else {
        <div class="flex justify-center items-center p-8">
            <mat-spinner></mat-spinner>
        </div>
    }

    <div class="flex justify-end p-4 sticky bottom-0 bg-white dark:bg-slate-800">
        <button class="mr-2" mat-raised-button color="primary" (click)="closeDialog()">
            {{ 'workerAssignments.close' | transloco }}
        </button>
    </div>
</div>